import { EncounterSignOff, GroupVisitSessionControllerApi } from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  sessionId: string;
  encounterSignOff: EncounterSignOff;
};

/**
 * Signs the session's shared group note and completes the session, as the
 * individual encounter sign-off does.
 *
 * @author Rajkumar Rathod
 */
export const useSignOffGroupNote = () =>
  useMutationWithLoading(async ({ sessionId, encounterSignOff }: Params) =>
    new GroupVisitSessionControllerApi(getConfigObject()).signOffGroupNote(
      sessionId,
      encounterSignOff,
      getXtenantId()
    )
  );
